export function TorontoLicensing() {
  const steps = [
    {
      number: '01',
      title: 'Verify Eligibility',
      description:
        'Confirm the property is your principal residence where you live at least 6 months per year.',
      details: [
        'Must be your primary home',
        'Proof of residence required',
        'Cannot be a secondary property',
      ],
    },
    {
      number: '02',
      title: 'Create Account',
      description:
        'Register on the City of Toronto STR registration portal with your personal information.',
      details: [
        'Government ID required',
        'Property address verification',
        'Contact information',
      ],
    },
    {
      number: '03',
      title: 'Submit Application',
      description: 'Complete the registration form and pay the annual fee.',
      details: [
        '$55 annual fee',
        'Declaration of principal residence',
        'Insurance confirmation',
      ],
    },
    {
      number: '04',
      title: 'Display Registration',
      description:
        'Once approved, display your registration number on all rental listings.',
      details: [
        'Unique registration number',
        'Must appear on all platforms',
        'Annual renewal required',
      ],
    },
  ];

  return (
    <section
      id="licensing"
      className="py-24 lg:py-32 bg-[#F8F8F8]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Registration Process
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            How to Register Your Toronto STR
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Follow these steps to register your short-term rental with the City of
            Toronto and operate legally. Most applications are instant, but flagged addresses may take 5–10 business days.
          </p>
        </div>

        <div className="grid lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-2xl p-8 h-full shadow-sm hover:shadow-lg transition-all">
                <div className="text-5xl font-bold text-[#882629]/20 mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-semibold text-[#505A5A] mb-3">
                  {step.title}
                </h3>
                <p className="text-[#505A5A]/70 mb-4 leading-relaxed">
                  {step.description}
                </p>
                <ul className="space-y-2">
                  {step.details.map((detail, idx) => (
                    <li
                      key={idx}
                      className="flex items-start gap-2 text-sm text-[#505A5A]/60"
                    >
                      <i className="ri-check-line text-[#882629] mt-0.5"></i>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-2xl text-[#882629]/30"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl p-8 shadow-sm">
          <h3 className="text-2xl font-semibold text-[#505A5A] mb-6 flex items-center gap-3">
            <i className="ri-information-line text-[#882629]"></i>
            Important 2026 Requirements
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#882629]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-calendar-check-line text-[#882629]"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#505A5A] mb-1">180-Night Cap</h4>
                <p className="text-sm text-[#505A5A]/70">Entire home rentals limited to 180 nights per year. Private rooms have no limit.</p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#882629]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                <i className="ri-percent-line text-[#882629]"></i>
              </div>
              <div>
                <h4 className="font-medium text-[#505A5A] mb-1">8.5% MAT Tax</h4>
                <p className="text-sm text-[#505A5A]/70">Must collect and remit Municipal Accommodation Tax on all bookings.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
